import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Dialog from '../../../../components/ModalDialog'
import { TextField } from '@mui/material'
import CreateIcon from '../../../../assets/icons/settingsCorner/iconsCreate'
import EditIcon from '../../../../assets/icons/settingsCorner/iconEdit'
import {
  StyledDivContent,
  StyledDivFullWidth,
  StyledDivTopInputs,
  StyledInputModal,
  StyledInputTitle,
  sxInput,
} from '../../styled'
import { useFormik } from 'formik'

import AutoComplete from '../../../../components/AutoComplete'

// which keys are symmetrical to our values/initialValues
const validate = ({ accountNumber, accountName }) => {
  const errors = {}
  if (!accountNumber) {
    errors.accountNumber = 'Numéro est obligatoire'
  }

  if (!accountName) {
    errors.accountName = 'Nom est obligatoire'
  }

  return errors
}

function CompteTiersModal({
  open,
  isEdit,
  handleClose,
  modalTitle,
  createCompteTiers,
  updateCompteTiers,
  isLoadingCompteTiersAction,
  success,
  errorMessage,
  row,
  resetCompteTiersConfig,

  salesChannelList,
  isLoadingSalesChannelList,
  getSalesChannels,
  getSalesChannelsMore,
  salesChannelListCount,

  keys,
  fetchKeys,
  searchKeys,
  isLoadingKeysList,
  fetchMoreKeys,
  keysCount,
  resetKey,
  errorMessageConfig,
}) {
  const [init, setInit] = useState(false)

  const [selectSalesChannel, setSelectSalesChannel] = useState(false)
  const [searchSalesChannel, setSearchSalesChannel] = useState('')
  const [offsetSalesChannel, setOffsetSalesChannel] = useState(25)
  const [openListOptionsSalesChannels, setOpenListOptionsSalesChannels] =
    useState(false)

  const [select, setSelect] = useState(false)
  const [searchKey, setSearchKey] = useState('')
  const [offset, setOffset] = useState(25)
  const [openListOptions, setOpenListOptions] = useState(false)

  const formik = useFormik({
    initialValues: {
      accountNumber: '',
      accountName: '',
      keys: [],
      salesChannels: [],
    },
    validate,
    onSubmit: (values) => {
      if (isEdit) {
        updateCompteTiers(values, row.id)
      } else {
        createCompteTiers(values)
      }
    },
  })

  useEffect(() => {
    fetchKeys()
    getSalesChannels({ offset: 0, limit: 25 })
    setInit(true)
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchSalesChannel.length > 0 && !selectSalesChannel) {
        getSalesChannels({ offset: 0, limit: 25, query: searchSalesChannel })
        setOffsetSalesChannel(25)
      } else if (searchSalesChannel == '') {
        if (init) {
          getSalesChannels({ offset: 0, limit: 25 })
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchSalesChannel])

  const onChangeSearchSalesChannel = (value) => {
    setSelectSalesChannel(false)
    if (value) {
      let val = value.trim()
      setSearchSalesChannel(val)
    } else {
      setSearchSalesChannel('')
      setSelectSalesChannel(false)
    }
  }

  const onSelectSalesChannel = (value) => {
    if (value) {
      console.log('onSelectSalesChannel===>', value)
      console.log('formik-salesChannels===>', formik.values.salesChannels)

      formik.setFieldValue('salesChannels', value)
      setSelectSalesChannel(true)
    }
  }

  const loadMoreSalesChannels = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      salesChannelListCount >= offsetSalesChannel
    ) {
      setOffsetSalesChannel(offsetSalesChannel + 25)
      getSalesChannelsMore({
        offset: offsetSalesChannel,
        limit: 25,
        query: searchKey,
      })
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', resetKey)

    return () => {
      resetKey()
      window.removeEventListener('beforeunload', resetKey)
    }
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchKey.length > 0 && !select) {
        searchKeys(searchKey)
        setOffset(25)
      } else if (searchKey === '') {
        if (init) {
          searchKeys('')
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchKey])

  const onChangeSearchKey = (value) => {
    setSelect(false)
    if (value) {
      let val = value.trim().toUpperCase()
      setSearchKey(val)
    } else {
      setSearchKey('')
      setSelect(false)
    }
  }

  const onSelectKey = (value) => {
    if (value) {
      console.log('onSelectKey===>', value)
      console.log('formik-Keys===>', formik.values.keys)

      formik.setFieldValue('keys', value)
      setSelect(true)
    }
  }

  const loadMoreKeys = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      keysCount >= offset
    ) {
      setOffset(offset + 25)
      fetchMoreKeys(offset, searchKey)
    }
  }

  useEffect(() => {
    if (isEdit) {
      formik.setValues({
        ...formik.values,
        accountNumber: row.accountNumber,
        accountName: row.accountName,
        keys: row.keys,
        salesChannels: row.salesChannels,
        id: row.id,
      })
    }
  }, [isEdit])

  useEffect(() => {
    if (success) {
      handleClose()
      resetCompteTiersConfig()
    }
  }, [success])

  const verifEdit = () => {
    return (
      isEdit &&
      formik.values.accountNumber == row.accountNumber &&
      formik.values.accountName == row.accountName &&
      JSON.stringify(formik.values.keys) == JSON.stringify(row.keys) &&
      JSON.stringify(formik.values.salesChannels) ==
        JSON.stringify(row.salesChannels)
    )
  }
  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <Dialog
        maxWidthDialog={'md'}
        open={open}
        title={modalTitle}
        iconTitle={isEdit ? <EditIcon /> : <CreateIcon />}
        style={{ display: (errorMessage || errorMessageConfig) && 'none' }}
        content={
          <StyledDivContent>
            <StyledDivTopInputs>
              <StyledInputModal>
                <StyledInputTitle>Nom compte *</StyledInputTitle>
                <TextField
                  placeholder="Nom compte	"
                  id="compteTiers-Nom"
                  name="accountName"
                  variant="outlined"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    sx: sxInput,
                  }}
                  value={formik.values.accountName}
                  error={formik.errors.accountName && formik.touched.accountName}
                  helperText={
                    formik.errors.accountName && formik.touched.accountName
                      ? formik.errors.accountName
                      : null
                  }
                />
              </StyledInputModal>
              <StyledInputModal>
                <StyledInputTitle>Numéro compte *</StyledInputTitle>
                <TextField
                  id="compteTiers-Numero"
                  name="accountNumber"
                  variant="outlined"
                  placeholder="Numéro compte"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    sx: sxInput,
                  }}
                  value={formik.values.accountNumber}
                  error={formik.errors.accountNumber && formik.touched.accountNumber}
                  helperText={
                    formik.errors.accountNumber && formik.touched.accountNumber
                      ? formik.errors.accountNumber
                      : null
                  }
                />
              </StyledInputModal>
            </StyledDivTopInputs>
            <StyledDivFullWidth withoutHeight>
              <StyledInputTitle>Canal vente </StyledInputTitle>
              <div style={{ display: 'flex' }}>
                <AutoComplete
                  freeSolo
                  value={formik.values.salesChannels}
                  name={'salesChannels'}
                  onChange={(event, value) => {
                    onSelectSalesChannel(value)
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value.name
                  }
                  onInputChange={(event, value) => onChangeSearchSalesChannel(value)}
                  id="Canal-list"
                  options={salesChannelList}
                  getOptionLabel={(option) => option.name}
                  variant="outlined"
                  placeholder={'Choisir un canal'}
                  sxInputStyle={sxInput}
                  multiple={true}
                  fullWidth={true}
                  ListboxProps={{
                    onScroll: loadMoreSalesChannels,
                  }}
                  renderOption={(props, option, index) => (
                    <li key={index.index} id={`canal-${option.id}`} {...props}>
                      <div className="AutoCompteFilterOption">{option.name}</div>
                    </li>
                  )}
                  loading={isLoadingSalesChannelList}
                  inputValue={searchSalesChannel}
                  open={openListOptionsSalesChannels}
                  onBlur={() => setOpenListOptionsSalesChannels(false)}
                  onFocus={() => setOpenListOptionsSalesChannels(true)}
                  onClose={(event, reason) => {
                    if (reason === 'escape' || reason === 'blur') {
                      setOpenListOptionsSalesChannels(false)
                    }
                  }}
                  onClick={() => setOpenListOptionsSalesChannels(true)}
                  withoutHeight
                />
              </div>
            </StyledDivFullWidth>
            <StyledDivFullWidth withoutHeight>
              <StyledInputTitle>Clé </StyledInputTitle>
              <div style={{ display: 'flex' }}>
                <AutoComplete
                  freeSolo
                  value={formik.values.keys}
                  name={'keys'}
                  onChange={(event, value) => {
                    onSelectKey(value)
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  onInputChange={(event, value) => onChangeSearchKey(value)}
                  id="compteTiers-Competances"
                  options={keys}
                  getOptionLabel={(option) => option.value}
                  variant="outlined"
                  placeholder={'Choisir une compétence'}
                  sxInputStyle={sxInput}
                  multiple={true}
                  error={formik.errors.keys && formik.touched.keys}
                  helperText={
                    formik.errors.keys && formik.touched.keys
                      ? formik.errors.keys
                      : null
                  }
                  fullWidth={true}
                  ListboxProps={{
                    onScroll: loadMoreKeys,
                  }}
                  renderOption={(props, option) => (
                    <li {...props} id={`Compétences-${option.id}`} key={option.id}>
                      <div className="AutoCompteFilterOption">{option.value}</div>
                    </li>
                  )}
                  loading={isLoadingKeysList}
                  inputValue={searchKey}
                  open={openListOptions}
                  onBlur={() => setOpenListOptions(false)}
                  onFocus={() => setOpenListOptions(true)}
                  onClose={(event, reason) => {
                    if (reason === 'escape' || reason === 'blur') {
                      setOpenListOptions(false)
                    }
                  }}
                  onClick={() => setOpenListOptions(true)}
                />
              </div>
            </StyledDivFullWidth>
          </StyledDivContent>
        }
        handleClose={handleClose}
        handleClickAction={formik.handleSubmit}
        disabled={verifEdit()}
        isLoadingButtonAction={isLoadingCompteTiersAction}
      />{' '}
    </form>
  )
}
CompteTiersModal.propTypes = {
  open: PropTypes.bool,
  isEdit: PropTypes.bool,
  handleClose: PropTypes.func,
  modalTitle: PropTypes.string,
  createCompteTiers: PropTypes.func,
  updateCompteTiers: PropTypes.func,
  isLoadingCompteTiersAction: PropTypes.bool,
  success: PropTypes.bool,
  errorMessage: PropTypes.string,
  row: PropTypes.object,
  resetCompteTiersConfig: PropTypes.func,

  salesChannelList: PropTypes.array,
  isLoadingSalesChannelList: PropTypes.bool,
  getSalesChannels: PropTypes.func,
  getSalesChannelsMore: PropTypes.func,
  salesChannelListCount: PropTypes.number,

  keys: PropTypes.array,
  fetchKeys: PropTypes.func,
  isLoadingKeysList: PropTypes.bool,
  searchKeys: PropTypes.func,
  fetchMoreKeys: PropTypes.func,
  keysCount: PropTypes.number,
  resetKey: PropTypes.func,
  errorMessageConfig: PropTypes.string,
}

export default CompteTiersModal
